import { channelTypeInfo } from "../models/ChannelType";
import AddressGeneratorUtils, { getGaFromCollection } from "./AddressGeneratorUtils";
import Consumer from "../models/Consumer";
import GroupAddress from "../models/GroupAdress";
import generateAddressesForConsumer_3 from "./generateAddressesForConsumer_3";

import Logger from "../Logger";
const logger = new Logger();

export default function generateAddressesForConsumer_B(consumer: Consumer, mainGroup: GroupAddress) {
  if (!channelTypeInfo(consumer.channelType).isSupply) {
    // no GroupAdrsses for fixed PowerSupply

    // consumer.signals.clear();

    let consumerClass = consumer.channelType.toString();
    let consumerIndex = AddressGeneratorUtils.getAddressForChannelTypeLevel2(consumer.channelType); // From state

    let name = state.translate(`channelType.${consumerClass}`, consumerClass);

    if (channelTypeInfo(consumer.channelType).isRollo) {
      name = state.translate("channelType.Shading", "Shading");
    }

    // Level 2 Address: Type (Switch, Dimm,)

    let middleGroup = getGaFromCollection(mainGroup.children, (g) => g.address == `${consumerIndex}`);

    if (middleGroup) {
      middleGroup.name = name;
      if (middleGroup.parent != mainGroup) {
        logger.log(`middleGroup's parent is not mainGroup: ${middleGroup.fullTag} ${middleGroup.name}`);
      }
    } else {
      middleGroup = GroupAddress.createNewGroupAddress({
        level: 2,
        name: name,
        address: consumerIndex,
        parent: mainGroup,
      });
    }

    generateAddressesForConsumer_3(consumer, middleGroup);
  }
}
